import { c as _c } from "react/compiler-runtime";
import { EM_DASH } from "@opensea/i18n";
import { classNames, Flex, FlexColumn, ItemContent, ItemDescription, ItemSide, ItemTitle, NumberDisplay, Skeleton, TextBody } from "@opensea/ui-kit";
import { Item } from "../Item";
const OrdersSummary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FlexColumn className="my-4 gap-4">{children}</FlexColumn>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const OrdersSummaryItem = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Item className={t1} variant="unstyled">{children}</Item>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const OrdersSummaryTokenValue = t0 => {
  const $ = _c(27);
  const {
    value,
    usdValue,
    symbol,
    isFee: t1,
    variant: t2,
    overrides
  } = t0;
  const isFee = t1 === undefined ? false : t1;
  const variant = t2 === undefined ? "value" : t2;
  const t3 = variant === "value";
  const t4 = variant === "result";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = classNames({
      "items-baseline gap-1.5": t3,
      "flex-col-reverse items-end": t4
    });
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = overrides?.Text;
  const t7 = overrides?.Text?.className;
  let t8;
  if ($[3] !== t7) {
    t8 = classNames("text-nowrap font-mono", t7);
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = isFee && value !== 0 ? EM_DASH : null;
  let t10;
  if ($[5] !== usdValue) {
    t10 = <NumberDisplay display="usd" value={usdValue} />;
    $[5] = usdValue;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== t10 || $[8] !== t6 || $[9] !== t8 || $[10] !== t9) {
    t11 = <TextBody color="text-secondary" size="xs" {...t6} className={t8}>({t9}{t10})</TextBody>;
    $[7] = t10;
    $[8] = t6;
    $[9] = t8;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = variant === "result" ? "semibold" : undefined;
  const t13 = overrides?.Text;
  const t14 = overrides?.Text?.className;
  let t15;
  if ($[12] !== t14) {
    t15 = classNames("text-nowrap font-mono", t14);
    $[12] = t14;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  const t16 = isFee && value !== 0 ? EM_DASH : null;
  let t17;
  if ($[14] !== symbol || $[15] !== value) {
    t17 = <NumberDisplay suffix={symbol} value={value} />;
    $[14] = symbol;
    $[15] = value;
    $[16] = t17;
  } else {
    t17 = $[16];
  }
  let t18;
  if ($[17] !== t12 || $[18] !== t13 || $[19] !== t15 || $[20] !== t16 || $[21] !== t17) {
    t18 = <TextBody weight={t12} {...t13} className={t15}>{t16}{t17}</TextBody>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t15;
    $[20] = t16;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t11 || $[24] !== t18 || $[25] !== t5) {
    t19 = <Flex className={t5}>{t11}{t18}</Flex>;
    $[23] = t11;
    $[24] = t18;
    $[25] = t5;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  return t19;
};
const OrdersSummaryTokenValueSkeleton = t0 => {
  const $ = _c(7);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "value" : t1;
  const t2 = variant === "value";
  const t3 = variant === "result";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames({
      "items-baseline gap-1.5": t2,
      "flex-col-reverse items-end": t3
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Skeleton className="h-3 w-10" />;
    t6 = <Skeleton className="h-3.5 w-14" />;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4) {
    t7 = <Flex className={t4}>{t5}{t6}</Flex>;
    $[5] = t4;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};
const OrdersSummaryItemSide = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let restProps;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = restProps;
  } else {
    children = $[1];
    className = $[2];
    restProps = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("max-w-none", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== restProps || $[8] !== t1) {
    t2 = <ItemSide {...restProps} className={t1}>{children}</ItemSide>;
    $[6] = children;
    $[7] = restProps;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export { OrdersSummary, OrdersSummaryItem, ItemContent as OrdersSummaryItemContent, ItemTitle as OrdersSummaryItemTitle, ItemDescription as OrdersSummaryItemDescription, OrdersSummaryItemSide, OrdersSummaryTokenValue, OrdersSummaryTokenValueSkeleton };